import React from "react";
import { useTranslation } from "react-i18next";
import InfiniteScrollTrigger from "components/infinite-scroll/InfiniteScrollTrigger";
import Card from "components/card/Card";
import { skeletonGenerator } from "components/infinite-scroll/helpers";
import ProgramSkeleton from "components/infinite-scroll/skeletons/ArticleSkeleton";

const MainContentList = ({
  selectedItems,
  setSelectedItems,
  items,
  isLoadingNextPage,
  hasMoreItems,
  getNextPage,
  page,
  setPage,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className="w-full h-full overflow-y-auto"
      style={{
        background: "#e2e2e2",
      }}
    >
      <div className="m-auto">
        <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
          {items.map((item) => {
            const {
              title,
              poster,
              images,
              description,
              id,
              author,
              categories,
              lessonClass,
            } = item;
            const isSelected = selectedItems.find((i) => i.id === id);
            return (
              <Card
                key={id}
                title={title}
                image={poster || images.cover}
                categories={categories}
                description={description}
                primaryButtonText={
                  isSelected ? t("courses.remove") : t("courses.add")
                }
                showSecondaryButton={false}
                onPrimaryButtonClick={() => {
                  isSelected
                    ? setSelectedItems(selectedItems.filter((i) => i.id !== id))
                    : setSelectedItems([...selectedItems, item]);
                }}
                author={author}
                primaryButtonColor={isSelected ? "error" : "primary"}
                lessonClass={lessonClass}
              />
            );
          })}
          {isLoadingNextPage && skeletonGenerator(<ProgramSkeleton />)}
          <InfiniteScrollTrigger
            isLoading={isLoadingNextPage}
            hasMoreItems={hasMoreItems}
            callback={getNextPage}
            page={page}
            setPage={setPage}
          />
        </div>
      </div>
    </div>
  );
};

export default MainContentList;
